import {
  HealthApi, VehicleHealth, MaintenanceItemUpdateBody // eslint-disable-line no-unused-vars
} from '@clients/myTrips'
import { AxiosPromise } from 'axios' // eslint-disable-line no-unused-vars
import appendCredentials from '@util/appendCredentials'
import getBasePath from '@util/path'

let basePath = getBasePath()

export default class ExtendedHealthApi extends HealthApi {
  checkMaintenanceItem (vehicleId: number, maintenanceItemId: string, MaintenanceItemUpdateBody: MaintenanceItemUpdateBody, options?: any): AxiosPromise<void> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.checkMaintenanceItem(vehicleId, maintenanceItemId, MaintenanceItemUpdateBody, undefined, options)
  }

  getVehicleHealth (vehicleId: number, options?: any): AxiosPromise<VehicleHealth> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.getVehicleHealth(vehicleId, undefined, options)
  }
}
